import { render, staticRenderFns } from "./FiltroEstabelecimentos.vue?vue&type=template&id=1801ef24&"
import script from "./FiltroEstabelecimentos.vue?vue&type=script&lang=js&"
export * from "./FiltroEstabelecimentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports